import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceEmailRoute: InvariantJiraRoute = {
	name: 'csm-experience-email',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/email',
	exact: true,
};
